import Vue from 'vue';
const bus = new Vue();

export default {
  $on(...event) {
    bus.$on(...event);
  },
  $off(...event) {
    bus.$off(...event);
  },
  $once(...event) {
    bus.$once(...event);
  },
  $emit(...event) {
    bus.$emit(...event);
  },
};



// WEBPACK FOOTER //
// ./src/plugins/eventBus.js